import React from 'react';

const About = () => {
  return (
    <section className='section about-section'>
      <h1>about us</h1>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quia debitis
        fugiat odio magni ipsam perferendis laboriosam atque nisi similique
        repellat explicabo saepe blanditiis aperiam deleniti veritatis enim,
        quam obcaecati deserunt quo quas libero nostrum aliquam? Nostrum quis
        velit optio iusto.
      </p>
    </section>
  );
};

export default About;
